export const dealersKeys = {
    all: () => ["dealers"],
    list: (filterText) => [...dealersKeys.all(), filterText],
    byId: (dealerId) => [...dealersKeys.all(), dealerId],
    duplicateName: (name) => [...dealersKeys.all(), "duplicate-name", name],
};
export const managedDealersKeys = {
    all: () => ["managed-dealers"],
    list: (filterText, sorting, page, pageSize) => [
        ...managedDealersKeys.all(),
        filterText,
        sorting,
        page,
        pageSize,
    ],
};
export const transportersKeys = {
    all: () => ["transporters"],
    list: (filterText) => [...transportersKeys.all(), filterText],
};
export const twoFactorKeys = {
    all: () => ["two-factor"],
    providers: () => [...twoFactorKeys.all(), "providers"],
    canEnable: () => [...twoFactorKeys.all(), "can-enable"],
    isEnabled: () => [...twoFactorKeys.all(), "is-enabled"],
};
export const usaStatesKeys = {
    all: () => ["usa-states"],
};
export const pricingHistoryKeys = {
    all: () => ["pricing-history"],
    list: (params) => [...pricingHistoryKeys.all(), params],
};
export const bolHistoryKeys = {
    all: () => ["bol-history"],
    list: (vin) => [...bolHistoryKeys.all(), vin],
    url: (id) => [...bolHistoryKeys.all(), "url", id],
};
export const companyReportsKeys = {
    all: () => ["company-reports"],
    settings: (companyId) => ["company-reports-setting", companyId],
    count: (companyId) => [...companyReportsKeys.all(), "count", companyId],
    types: (companyType) => ["company-reports-types", companyType],
    history: (companyId, type) => ["company-reports-history", companyId, type],
};
export const transporterLoadsKeys = {
    all: () => ["transporter-loads"],
    list: (page, pageSize, filter, sorting, status) => [
        ...transporterLoadsKeys.all(),
        page,
        pageSize,
        filter,
        sorting,
        status,
    ],
};
export const vehicleBreakpointsKeys = {
    all: () => ["vehicle-breakpoints"],
    breakpoint: (vehicleType, curbWeight) => [...vehicleBreakpointsKeys.all(), vehicleType, curbWeight],
};
export const tagGroupsKeys = {
    all: () => ["tag-groups"],
};
export const tagsKeys = {
    all: () => ["tags"],
    list: (filterText, sorting, group, isActive, page, pageSize) => [...tagsKeys.all(), filterText, sorting, group, isActive, page, pageSize],
};
export const activeTagsKeys = {
    all: () => ["active-tags"],
    byGroup: (group) => [...activeTagsKeys.all(), group],
};
export const assignedTagsKeys = {
    all: () => ["assigned-tags"],
    byGroup: (entityType) => [...assignedTagsKeys.all(), entityType],
    byEntity: (entityType, entityId) => [...assignedTagsKeys.all(), entityType, entityId],
};
export const pickupDatesKeys = {
    all: () => ["etaDates", "pickup"],
    byShipmentId: (shipmentId, startDate) => [
        ...pickupDatesKeys.all(),
        shipmentId,
        startDate,
    ],
};
export const dropoffDatesKeys = {
    all: () => ["etaDates", "dropoff"],
    byShipmentId: (shipmentId, pickupDate) => [
        ...dropoffDatesKeys.all(),
        shipmentId,
        pickupDate,
    ],
};
export const gatePassKeys = {
    all: () => ["gate-passes"],
    activeJobs: () => [...gatePassKeys.all(), "active-jobs"],
    resultsAll: () => [...gatePassKeys.all(), "results"],
    results: (page, pageSize, sorting, jobId, status, dealerId, creatorId, filter) => [...gatePassKeys.resultsAll(), page, pageSize, sorting, jobId, status, dealerId, creatorId, filter],
};
export const dealerNamesKeys = {
    all: () => ["dealer-names"],
    byIds: (ids) => [...dealerNamesKeys.all(), (ids ?? []).sort()],
};
export const notesKeys = {
    all: () => ["notes"],
    byCategory: (entityId, category, includeHidden = false) => [
        ...notesKeys.all(),
        entityId,
        category,
        includeHidden,
    ],
    list: (category, entityId, page, pageSize, sorting, includeHidden = false) => [...notesKeys.all(), entityId, category, page, pageSize, sorting, includeHidden],
};
export const notesCategoriesKeys = {
    all: () => ["notes-categories"],
    byType: (type) => [...notesCategoriesKeys.all(), type],
    byEntityId: (entityId) => [...notesCategoriesKeys.all(), entityId],
};
export const campaignsKeys = {
    all: () => ["campaigns"],
    active: (userType) => [...campaignsKeys.all(), "active", userType],
    list: (page, pageSize, sorting, filter) => [
        ...campaignsKeys.all(),
        page,
        pageSize,
        sorting,
        filter,
    ],
};
export const pricingSettingKeys = {
    all: () => ["pricing-settings"],
    canAutoAccept: (dealerId) => [...pricingSettingKeys.all(), "can-auto-accept", dealerId],
};
export const quickQuoteKeys = {
    all: () => ["quick-quotes"],
    activeJobs: () => [...quickQuoteKeys.all(), "active-jobs"],
    resultsAll: () => [...quickQuoteKeys.all(), "results"],
    results: (page, pageSize, sorting, filter, dealerId, isPending, status, managerId, notConverted) => [
        ...quickQuoteKeys.resultsAll(),
        page,
        pageSize,
        sorting,
        filter,
        dealerId,
        isPending,
        status,
        managerId,
        notConverted,
    ],
};
export const vehicleLookupKeys = {
    all: () => ["vehicle-lookups"],
    makes: (year, searchText = "") => [...vehicleLookupKeys.all(), "makes", year, searchText],
    models: (year, make, searchText = "") => [
        ...vehicleLookupKeys.all(),
        "models",
        year,
        make,
        searchText,
    ],
    trims: (year, make, model, searchText = "") => [
        ...vehicleLookupKeys.all(),
        "trims",
        year,
        make,
        model,
        searchText,
    ],
    sizes: (year, make, model, trim, searchText = "") => [
        ...vehicleLookupKeys.all(),
        "sizes",
        year,
        make,
        model,
        trim,
        searchText,
    ],
};
export const billTransactionsKeys = {
    all: () => ["bill-transactions"],
    byLoadId: (loadId) => [...billTransactionsKeys.all(), loadId],
};
export const termsAndConditionsAcceptanceStatusKeys = {
    all: () => ["terms-and-conditions-acceptance-status"],
};
export const notificationTemplatesKeys = {
    all: () => ["notification-templates"],
    byRoleType: (roleType) => [...notificationTemplatesKeys.all(), roleType],
};
export const currentNotificationSettingsKeys = {
    all: () => ["current-notification-settings"],
};
export const notificationLogsKeys = {
    all: () => ["notification-logs"],
    list: (entityId, page, pageSize) => [
        ...notificationLogsKeys.all(),
        entityId,
        page,
        pageSize,
    ],
};
export const termsDocumentsKeys = {
    all: () => ["terms-documents"],
    active: (type) => [...termsDocumentsKeys.all(), "active", type],
};
export const smsCategoriesKeys = {
    all: () => ["sms-categories"],
    byRoleType: (roleType) => [...smsCategoriesKeys.all(), roleType],
};
export const verificationKeys = {
    all: () => ["verification"],
    checkRequired: (shipmentId) => [...verificationKeys.all(), "check-required", shipmentId],
    sessionStatus: (verificationId) => [...verificationKeys.all(), "session-status", verificationId],
};
export const shipmentHoldKeys = {
    all: () => ["shipment-hold"],
    byShipment: (shipmentId) => [...shipmentHoldKeys.all(), shipmentId],
};
